export const transformListForSelect = (list = [], key:string = null, keyValue:string = '') => {
    if(!key || !keyValue) return list;

    return list.map((item) => {
        return {
            ...item,
            label: item[key],
            value: item[keyValue]
        }
    })
}

export const removeFromList = (list:unknown[], index:number) => {
    return list.filter((_, i) => i !== index)
}

/**
 * Помечает опции уже добавленных файлов как недоступные.
 *
 * Список файлов больше не прячет привязанные к видео файлы (в папке студии
 * было 128 файлов, из них 12 привязаны — пользователь видел 116 и считал, что
 * файлы пропали). Но выбрать такой файл нельзя: повторное добавление отклоняет
 * бэкенд. Поэтому опция остаётся видимой, но disabled и с пояснением в метке.
 *
 * Исходный массив не мутируется, `value` не меняется — иначе сломается выбор.
 *
 * @param allowedPaths пути, уже занятые в текущей (несохранённой) форме:
 *        multi-audio штатно берёт из одного файла несколько дорожек, поэтому
 *        такой файл обязан остаться выбираемым (D-6).
 */
export const markAddedOptionsDisabled = (options:any[] = [], allowedPaths:string[] = []) => {
    return options.map((option) => {
        if(!option || !option.is_added) return option;

        if(allowedPaths.includes(option.value)) return option;

        return {
            ...option,
            label: `${option.label} — уже добавлен`,
            disabled: true
        }
    })
}